import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { PLUS_3, PLUS_3_1 } from 'src/defaultImages.js';

@Component({
  selector: 'app-time-increment',
  templateUrl: './time-increment.component.html',
  styleUrls: ['./time-increment.component.css'],
})
export class TimeIncrementComponent implements OnInit {
  images = { 
    PLUS_3: PLUS_3,
    PLUS_3_1: PLUS_3_1
  }
  @Output() selectedDuration: EventEmitter<any> = new EventEmitter<any>();
  @Input() title: any;
  @Input() isDisabled = false;
  public number = 15;
  constructor() {}

  ngOnInit() {}
  setNumber(target) {
    if (+target.value <= 0) {
      this.number = 0;
    } else {
      this.number = +target.value;
    }
  }
  onIncrement() {
    this.number += 1;
    this.selectedDuration.emit({ name: this.title, minutes: this.number });
  }
  onDecrease() {
    if (this.number > 0) {
      this.number -= 1;
    }
    this.selectedDuration.emit({ name: this.title, minutes: this.number });
  }
}
